export const INTERNAL_ERROR = 'Something went wrong please try again';

export const CONTACT_TYPES = [
  { value: 'client', label: 'Client', color: 'primary' },
  { value: 'titling_company', label: 'Title Company', color: 'secondary' },
  { value: 'vendor', label: 'Vendor', color: 'info' },
  { value: 'other', label: 'Other', color: 'grey' }
]